<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-row>
          <v-col cols="12" lg="5" xl="5">
            <v-text-field
              filled
              data-cy="FormSupplier-name"
              :label="$$t('name')"
              v-model="localSupplier.name"
            />
          </v-col>
          <v-col cols="12" lg="5" xl="5">
            <v-text-field
              filled
              data-cy="FormSupplier-legalName"
              :label="$$t('legalName')"
              v-model="localSupplier.legalName"
            />
          </v-col>
          <v-col cols="12" lg="2" xl="2">
            <v-text-field
              filled
              data-cy="FormSupplier-vatNumber"
              :label="$$t('vatNumber')"
              v-model="localSupplier.vatNumber"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              filled
              data-cy="FormSupplier-address"
              :label="$$t('address')"
              v-model="localSupplier.address"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="4" xl="4">
            <v-text-field
              filled
              data-cy="FormSupplier-telephoneNumber"
              :label="$$t('telephoneNumber')"
              v-model="localSupplier.telephoneNumber"
            />
          </v-col>
          <v-col cols="12" lg="4" xl="4">
            <v-text-field
              filled
              data-cy="FormSupplier-email"
              :label="$$t('email')"
              v-model="localSupplier.email"
            />
          </v-col>
          <v-col cols="12" lg="4" xl="4">
            <v-text-field
              filled
              data-cy="FormSupplier-contact"
              :label="$$t('contact')"
              v-model="localSupplier.contact"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              filled
              data-cy="FormSupplier-notes"
              :label="$$t('notes')"
              v-model="localSupplier.notes"
              counter="2000"
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormSupplier-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormSupplier-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormSupplier',
  module: 'Suppliers',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    Supplier: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localSupplier
      */
      localSupplier: {},
    };
  },
  watch: {
    Supplier() {
      this.localSupplier = this.Supplier;
    },
  },
  created() {
    this.localSupplier = this.Supplier;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localSupplier);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormSupplier example

'''js
<FormSupplier :Supplier="Supplier" />
'''
</docs>
